import { ArrowUpRight, Clock } from "lucide-react";
import { DIRECTORY } from "@/data/tools";
import { ToolShell } from "@/components/tools/ToolShell";

export const ResourceDirectory = ({ id = "resource-directory", tool }) => (
  <ToolShell id={id} tool={tool} metaFields={false}>
    <ul className="grid gap-4 sm:grid-cols-2">
      {DIRECTORY.map((d) => (
        <li key={d.name} className="avoid-break rounded-2xl border-2 border-line bg-surface p-5" data-testid={`dir-${d.name.toLowerCase().replace(/\s+/g, "-")}`}>
          <p className="font-display text-xl font-medium">{d.name}</p>
          {d.desc && <p className="text-sm text-ink-soft">{d.desc}</p>}
          {d.soon ? (
            <p className="mt-3 inline-flex items-center gap-2 font-bold"><Clock size={16} aria-hidden /> Coming soon</p>
          ) : (
            <a href={`https://${d.url}`} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1.5 break-all font-bold text-brand underline-offset-4 hover:underline">
              {d.url} <ArrowUpRight size={16} aria-hidden /><span className="sr-only">(opens in a new tab)</span>
            </a>
          )}
        </li>
      ))}
    </ul>
  </ToolShell>
);
